export default {
  // 匹配v-modal
  rule: {
    type: Object,
    default: () => {},
    require: true
  },
  // 匹配输入项
  config: {
    type: Object,
    default: () => {},
    require: true
  }
}
